'use client';
import { jsx } from 'react/jsx-runtime';
import { Children, cloneElement, isValidElement } from 'react';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var o, r, i = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(t);
        for(r = 0; r < l.length; r++)o = l[r], !(e.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(t, o) && (i[o] = t[o]);
    }
    return i;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var o, r, i = {}, l = Object.keys(t);
    for(r = 0; r < l.length; r++)o = l[r], e.indexOf(o) >= 0 || (i[o] = t[o]);
    return i;
}
let s = renderWithRef('ListboxWithFloatingLabel', null, (i, n)=>{
    let { fullWidth: s = false, children: p } = i, c = _object_without_properties(i, [
        "fullWidth",
        "children"
    ]), b = new Set([
        'swan-vanilla-ignore',
        'swan-listbox-with-floating-label'
    ]);
    return s && b.add("swan-listbox-with-floating-label-full-width"), jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: n,
            props: c,
            classNames: b,
            children: Children.map(p, (t, e)=>0 === e && isValidElement(t) ? cloneElement(t, {
                    fullWidth: null != s ? s : void 0
                }) : t)
        })
    });
});
const ListboxWithFloatingLabel = deprecatedComponent({
    description: 'Use the generic component InputWithFloatingLabel instead',
    displayName: 'ListboxWithFloatingLabel',
    root: s
});

export { ListboxWithFloatingLabel };
